import React, { useState, useEffect, useContext } from 'react'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import Image from 'react-bootstrap/Image'

import './App.css';

import logoimg from "./img/logo.png"

function Login() {
  const { logged, searchText, btnDisabled, mailBody, mailTitle, showWrongCredentials, getLogin, setShowWrongCredentials } = useContext(GlobalContext);

  const [ usuario, setUsuario ] = useState('')
  const [ pass, setPass ] = useState('')

  useEffect(() => {
    if( logged ) window.location.href = '/'
  }, [ logged ]);

  useEffect(() => {
  }, []);

  return (
    <div className="App">
      <Modal show={showWrongCredentials} onHide={ () => setShowWrongCredentials( false ) }>
        <Modal.Header closeButton>
          <div className="">{ mailTitle }</div>
        </Modal.Header>
        <Modal.Body>
          <div className="forgoten-pass"> { mailBody } </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={ () => setShowWrongCredentials( false ) }>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <Container align="center">
        <div className='container-login'>
          <div>
            <Image
              className="logo"
              src={logoimg}
            />
          </div>
          <br/>
          <div className='container-form' align="center">
            <div className='formulario'>
              <div>
                <Container>
                  <Row>
                    <Col md={12}>
                      <Form>
                        <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
                          <Form.Label>Usuario</Form.Label>
                          <Form.Control required type="text" placeholder="" value={ usuario } onChange={ (event) => setUsuario(event.target.value) }/>
                        </Form.Group>

                        <Form.Group className="mb-3" style={{ textAlign: 'left' }}>
                          <Form.Label>Contraseña</Form.Label>
                          <Form.Control required type="password" placeholder="" value={ pass } onChange={ (event) => setPass(event.target.value) }/>
                        </Form.Group>

                        <div className='forget-pass'> ¿Olvidaste tu contraseña? </div>

                        <div>
                          <Button className='btn-normal' type="submit" disabled={ btnDisabled } onClick={ () => getLogin( usuario, pass ) }>
                            <Spinner
                              className={ btnDisabled ? '' : 'hide'}
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                            { searchText }
                          </Button>
                        </div>
                      </Form>

                      <br/>
                      <br/>
                      <br/>
                      <Container>
                        <Row>
                          <Col> <div className='legal-footer'>Terminos y condiciones</div> </Col>
                          <Col> <div className='legal-footer'>Aviso de Privacidad</div> </Col>
                        </Row>
                      </Container>

                    </Col>
                  </Row>
                </Container>
              </div>
              <br/>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
  
export default Login;

  